export default {
  CUSTOM_PWD_TITLE: '用户密码规则',
  CUSTOM_BTN_EDIT: '编辑',
  CUSTOM_BTN_CONFIRM: '确认',
  CUSTOM_BTN_CANCEL: '取消'
}
